import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-list-one',
  templateUrl: './shop-list-one.component.html',
  styleUrls: ['./shop-list-one.component.scss']
})
export class ShopListOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
